import { successResponseMockStructure } from './successResponseMockStructure'

import { User } from '~types/user'

export const user: User = {
  id: 'd5d9ee4e-73b0-473b-bbdc-eaa2dea735a2',
  name: 'mwrty',
  email: 'mwrty12@mailinator.com',
  points: '96900',
  status: 1,
  address: {
    city: 'rr',
    state: 'UP',
    country: 'IN',
    address1: '112',
    postcode: '123456',
  },
  basicInfo: {
    birthDate: '',
    company: '',
    firstName: 'mwrty',
    gender: '',
    lastName: 'test',
    location: '',
    stateId: '',
    state: '',
    cityId: '',
    city: '',
    phone: '9988776655',
  },
}

export const mockUserResponse = successResponseMockStructure({ user })
